// Updated default data structure - removed status logic
export const DEFAULT_STATE_DEPARTMENTS_DATA = {
  financialYear: '',
  departments: [], // Start with empty array instead of pre-loaded departments
  totalAmount: 0,
  createdAt: null,
  updatedAt: null,
  createdBy: null
  // Removed status, submittedAt, submittedBy - no longer needed
};

// Validation limits
export const STATE_DEPARTMENTS_VALIDATION_LIMITS = {
  AMOUNT_MIN: 0,
  AMOUNT_MAX: 999999999, // 99 crores
  DEPT_NAME_MIN_LENGTH: 3,
  DEPT_NAME_MAX_LENGTH: 200
};

// Helper function to format amount display
export const formatDepartmentAmount = (amount) => {
  if (!amount || amount === 0) return '₹0.00';
  
  const numAmount = parseFloat(amount);
  if (isNaN(numAmount)) return '₹0.00';
  
  return `₹${numAmount.toFixed(2)}`;
};

// Helper function to calculate total
export const calculateDepartmentsTotal = (departments) => {
  return departments.reduce((total, dept) => {
    return total + (parseFloat(dept.amount) || 0);
  }, 0);
};

// Helper function to get available departments for dropdown
// This will filter out departments that are already selected
export const getAvailableDepartments = (allDepartments, selectedDepartments) => {
  const selectedValues = selectedDepartments.map(dept => dept.value || dept.id);
  return allDepartments.filter(dept => !selectedValues.includes(dept.value));
};

// Helper function to format amount with proper locale formatting
export const formatDepartmentAmountWithLocale = (amount) => {
  if (!amount || amount === 0) return '₹0.00';
  
  const numAmount = parseFloat(amount);
  if (isNaN(numAmount)) return '₹0.00';
  
  return `₹${numAmount.toLocaleString('en-IN', { 
    minimumFractionDigits: 2, 
    maximumFractionDigits: 2 
  })}`;
};

// Helper function to validate department data structure
export const validateDepartmentStructure = (department) => {
  return department && 
         department.id && 
         department.name && 
         typeof department.amount !== 'undefined';
};

// Helper function to generate department summary
export const generateDepartmentSummary = (departments) => {
  if (!departments || !Array.isArray(departments)) {
    return {
      count: 0,
      total: 0,
      average: 0,
      highest: null,
      lowest: null
    };
  }

  const amounts = departments
    .map(dept => parseFloat(dept.amount) || 0)
    .filter(amount => amount > 0);

  return {
    count: departments.length,
    total: calculateDepartmentsTotal(departments),
    average: amounts.length > 0 ? amounts.reduce((a, b) => a + b, 0) / amounts.length : 0,
    highest: amounts.length > 0 ? Math.max(...amounts) : 0,
    lowest: amounts.length > 0 ? Math.min(...amounts) : 0
  };
};